<main class="dsm-page">
  <header class="page-head">
    <div>
      <h1>Deviation Settlement Mechanism (DSM) Dashboard</h1>
      <p>Maharashtra State Load Dispatch Centre (MSLDC)</p>
    </div>
    <div class="head-actions">
      <label
        >▣
        <input
          type="date"
          [value]="selectedDate()"
          (change)="updateSelectedDate($any($event.target).value)"
      /></label>
    </div>
  </header>
  <section class="hero-kpis">
    <article class="current">
      <small>CURRENT BLOCK</small><strong>{{ currentBlockNumber }} / 96</strong
      ><b>{{ currentBlock() }} <i>● LIVE</i> </b> 
    </article>
    <article>
      <small>Scheduled Generation (MW)</small><strong>10,245.60</strong>
      <p class="kpi-change positive">vs Prev Block <b>↑ 2.15%</b></p>
    </article>
    <article>
      <small>Actual Generation (MW)</small><strong>10,736.35</strong>
      <p class="kpi-change positive">vs Prev Block <b>↑ 3.42%</b></p>
    </article>
    <article>
      <small>Deviation (MW)</small><strong class="text-success">+490.75</strong>
      <p class="kpi-change positive">vs Prev Block <b>↑ 5.18%</b></p>
    </article>
    <article>
      <small>Deviation (%)</small><strong class="text-success">4.79%</strong>
      <p class="kpi-change positive">vs Prev Block <b>↑ 0.62%</b></p>
    </article>
    <article>
      <small>Net Settlement Amount (₹)</small
      ><strong class="text-danger">-2,35,67,890</strong>
      <p class="kpi-change negative">vs Prev Block <b class="text-danger">↓ 1.87%</b></p>
    </article>
  </section>
  <section class="settlement-strip">
    <article>
      <i>↕</i><span>Over Injection (MW)<b >490.75</b></span>
    </article>
    <article>
      <i>↧</i><span>Under Injection (MW)<b>0.00</b></span>
    </article>
    <article>
      <i>▦</i
      ><span
        >Total Positive Settlement (₹)<b class="text-success"
          >3,12,45,670</b
        ></span
      >
    </article>
    <article>
      <i>↕</i
      ><span>Total Negative Settlement (₹)<b class="text-danger">-5,48,13,560</b></span>
    </article>
    <article>
      <i>◉</i
      ><span>Cleared Amount (₹)<b class="text-success">1,95,67,230</b></span>
    </article>
    <article>
      <i>◷</i
      ><span>Pending Amount (₹)<b class="text-danger">-39,80,660</b></span>
    </article>
  </section>
  <section class="charts-grid">
    <article #trendPanel class="panel chart-panel">
      <div class="chart-tools">
        <label>
          <select
            [value]="modes.trend"
            (change)="changeMode('trend', $any($event.target).value)"
          >
            <option value="time">Time-wise</option>
            <option value="block">Block-wise</option>
          </select></label
        ><button
          aria-label="Fullscreen deviation trend"
          (click)="toggleFullscreen(trendPanel)"
        >
          ⛶
        </button>
      </div>
      <div #trendChart class="highchart"></div>
    </article>
   
    <article #generationPanel class="panel chart-panel generation">
      <div class="chart-tools">
        <button
          aria-label="Fullscreen generation chart"
          (click)="toggleFullscreen(generationPanel)"
        >
          ⛶
        </button>
      </div>
      <div #generationChart class="highchart"></div>
    </article>
    <article #sourceSharePanel class="panel chart-panel source-share-panel">
      <div class="chart-tools">
        <button
          aria-label="Fullscreen deviation share"
          (click)="toggleFullscreen(sourceSharePanel)"
        >
          ⛶
        </button>
      </div>
      <div #sourceShareChart class="highchart"></div>
      <footer>Total Deviation: <b>490.75 MW</b></footer>
    </article>
  </section>
 
  <section class="dashboard-layout">
  <section class="tables-grid">
    <article class="panel entity current-deviations">
      <header class="entity-header">
        <h2>
          Top QCA / PSS / Generator Deviations <small>(Current Block)</small>
        </h2>
        <a>View All</a>
      </header>

      <div class="entity-tabs">
        @for (type of ["QCA", "PSS", "GENERATOR"]; track type) {
          <button
            [class.active]="entityView() === type"
            (click)="entityView.set($any(type))"
          >
            {{ type }}
          </button>
        }
      </div>
      <table>
        <thead>
          <tr>
            <th>Entity ID</th>
            <th>Entity Name</th>
            <th>Type</th>
            <th>Over Injection (MW)</th>
            <th>Under Injection (MW)</th>
            <th>Deviation (MW)</th>
            <th>Deviation (%)</th>
            <th>DSM Amount (₹)</th>
          </tr>
        </thead>
        <tbody>
          @for (row of entityRows(); track row.id) {
            <tr>
              <td><button class="entity-link" type="button" (click)="navigateToEntity(row)">{{ row.id }}</button></td>
              <td><button class="entity-link" type="button" (click)="navigateToEntity(row)">{{ row.name }}</button></td>
              <td>{{ row.type === "GENERATOR" ? "Generator" : row.type }}</td>
              <td>{{ row.overInjection | number: "1.2-2" }}</td>
              <td>{{ row.underInjection | number: "1.2-2" }}</td>
              <td>{{ row.deviation | number: "1.2-2" }}</td>
              <td>{{ row.deviationPercent | number: "1.2-2" }}%</td>
              <td class="dsm-amount">{{ row.dsmAmount | number: "1.0-0" }}</td>
            </tr>
          }
        </tbody>
      </table>
    </article>
    <article class="panel summary">
      <h2>Settlement Summary (₹)</h2>
      <a>View Details</a>

      <p>
        RE-DSM Payable (To Generators) <b class="green-text">3,12,45,670</b>
      </p>

      <p>RE-DSM Receivable (From Generators) <b class="red">-5,48,13,560</b></p>
      <p>Net Settlement Amount <b class="red">-2,35,67,890</b></p>
      <p>Cleared Amount <b class="blue-text">1,95,67,230</b></p>
      <p>Pending Amount <b class="orange-text">-39,80,660</b></p>
      <p>DPC / LPS Charges <b class="red">-6,87,120</b></p>
      <p>
        Corpus (RE Deviation Pool Account)
        <b class="green-text">25,48,76,320</b>
      </p>
    </article>
 
  </section>
  <section class="bottom-grid">
  
    <!--<article class="panel alerts">
      <header class="alerts-header">
        <h2>Recent Alerts</h2>
        <a>View All Alerts</a>
      </header>

      <div class="alerts-table-wrap">
        <table class="alerts-table">
          <thead>
            <tr>
              <th></th><th>Alert</th><th>Plant / PSS</th><th>Block</th>
              <th>Value</th><th>Severity</th><th>Time</th>
            </tr>
          </thead>
          <tbody>
            @for (alert of alerts; track alert.title + alert.time) {
              <tr>
                <td class="alert-icon"><i [class]="alert.severity">{{ alert.icon }}</i></td>
                <td class="alert-info"><b>{{ alert.title }}</b><small>{{ alert.detail }}</small></td>
                <td class="alert-plant"><span>{{ alert.plant }}</span></td>
                <td class="alert-block"><span>{{ alert.block }}</span></td>
                <td class="alert-value" [class.critical]="alert.severity === 'critical'" [class.warning]="alert.severity === 'warning'" [class.success]="alert.severity === 'success'">{{ alert.value }}</td>
                <td class="alert-status"><span [class]="alert.severity">{{ alert.status }}</span></td>
                <td><time>{{ alert.time }}</time></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </article>
  -->
     <article #districtMapPanel class="panel district-map-panel chart-panel">
      <header>
        <div>
          <h2>Maharashtra District Deviation Map</h2>
          <p>Current block deviation percentage by district</p>
        </div>
      
      </header>
      <div #districtMapFullscreen class="district-map-wrap">
        <div
          #districtMap
          class="district-map"
          aria-label="Google map of Maharashtra with district deviation polygons"
        ></div>
        <div #districtMapLegend class="district-map-legend" aria-label="Deviation percentage legend">
          <span class="high-positive">≥ +3% high deviation</span>
          <span class="positive">0% to +3% over-deviation</span>
          <span class="negative">-3% to 0% under-deviation</span>
          <span class="high-negative">≤ -3% high under-deviation</span>
          <span class="no-data">No data reported</span>
        </div>
        @if (googleMapsError) {
          <div class="district-map-error">
            Google Map could not be loaded. Check the Google Maps key in the active environment configuration.
          </div>
        }
      </div>
    </article>

       <article class="panel availability">
      <h2>Data Availability Status</h2>
      @for (item of availability; track item[0]) {
        <p>
          <span>{{ item[0] }}</span
          ><b><i></i>{{ item[1] }}</b>
        </p>
      }

    </article>
  
  </section>
  <article class="panel alerts alerts-side">
    <header class="alerts-header">
      <h2 >Recent Alerts</h2>
      <a>View All</a>
    </header>
    <div class="alerts-list">
      @for (alert of alerts; track alert.title + alert.time) {
        <article class="alert-item">
          <i class="alert-icon" [class]="alert.severity">{{ alert.icon }}</i>
          <div class="alert-info">
            <b>{{ alert.title }}</b>
            <small>{{ alert.detail }}</small>
          </div>
          <time>{{ alert.time }}</time>
        </article>
      }
    </div>
  </article>
  </section>
</main>
